module.exports = __webpack_public_path__ + "img/Asset-202-100.0c34effb.jpg";